
var msgCB = function(messageData) {
  if(messageData.message == 'resetScroll') {
    document.getElementById("cpatsframe").scrollIntoView(true)
  }
};
iFrameResize(
  {
    heightCalculationMethod: 'taggedElement',
    onMessage: msgCB,
    checkOrigin: false
  },
  '#cpatsframe'
);
